import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  tone?: "dark" | "light";
}

export default function SectionHeader({
  title,
  subtitle,
  icon = "ri-film-line",
  moreTo,
  moreLabel = "查看全部",
  tone = "dark",
}: SectionHeaderProps) {
  const isLight = tone === "light";
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-md ${
            isLight ? "bg-background-50/10 text-accent-400" : "bg-primary-50 text-primary-700"
          }`}
        >
          <i className={`${icon} text-lg`} />
        </span>
        <div>
          <h2
            className={`font-heading text-xl font-bold tracking-tight md:text-[22px] ${
              isLight ? "text-background-50" : "text-foreground-950"
            }`}
          >
            {title}
          </h2>
          {subtitle && (
            <p className={`mt-1 text-xs md:text-[13px] ${isLight ? "text-background-300" : "text-foreground-600"}`}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className={`group flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium transition-colors ${
            isLight
              ? "text-background-200 hover:text-accent-300"
              : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
          }`}
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}